/**
 * Firebase Service - Authentication and Firestore
 *
 * This module initializes Firebase for authentication and Firestore.
 * - Firebase Auth is used for user authentication (Google Sign-In, etc.)
 * - Firestore is used for roles/experts list and other frontend data
 * - Analytics is optional and loaded conditionally
 */

import { initializeApp } from 'firebase/app'
import { getAuth, GoogleAuthProvider } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getAnalytics, isSupported } from 'firebase/analytics'

console.log("Inicializando Firebase (prototipacao-ux)...");

// Configuração do projeto prototipacao-ux
const firebaseConfig = {
  apiKey: "AIzaSyB4Ebe9t_W6-r6pVdkhNM2js2lrPfCW1bo",
  authDomain: "prototipacao-ux.firebaseapp.com",
  projectId: "prototipacao-ux",
  storageBucket: "prototipacao-ux.firebasestorage.app",
  messagingSenderId: "11511352616",
  appId: "1:11511352616:web:b55a646ce03fed0bdb941d",
  measurementId: "G-TMP56GF5XJ"
};

console.log('Configuração Ativa Project ID:', firebaseConfig.projectId);

// Initialize Firebase
const app = initializeApp(firebaseConfig)

// Initialize Auth
export const auth = getAuth(app)
export const googleProvider = new GoogleAuthProvider()
googleProvider.setCustomParameters({
  prompt: 'select_account',
})

// Initialize Firestore (for roles/experts list)
export const db = getFirestore(app)

// Initialize Analytics (only in browser and if supported)
export const initAnalytics = async () => {
  try {
    if (await isSupported()) {
      return getAnalytics(app)
    }
  } catch (e) {
    console.warn("Analytics ignorado:", e);
  }
  return null
}

export default app
